export default function formatUTCDate(date, dateStringLength = 19) {
  if (!date || date === 'null') {
    return ''
  }

  const finalDate = new Date(date + 'UTC')
  return finalDate.toISOString().slice(0, dateStringLength)
}
